export const isOuterClick = (element: HTMLElement, container: HTMLElement) => {
  let target = element;
  while (target) {
    if (target === container) {
      return false;
    }
    target = target.parentNode as HTMLElement;
  }
  return true;
};
